export default __webpack_public_path__ + "static/media/saudeSim.d2752186.png";